import fetch from "auth/FetchInterceptor";

const LabService = {};

LabService.fetchLabTableData = function (param) {
  return fetch({
    url:
      "/specimen-tracking/lab-table-data?start_date=" +
      param.start_date +
      "&end_date=" +
      param.end_date,
    method: "get",
  });
};

LabService.labReceive = function (data) {
  return fetch({
    url: "/specimen-tracking/lab-receive",
    method: "post",
    data,
  });
};

LabService.drawHistory = function (sampleId) {
  return fetch({
    url:
      "/specimen-tracking/phlebotomy-draw-history-for-lab?sample_id=" +
      sampleId,
    method: "get",
  });
};
export default LabService;
